module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-3 col-xs-6 col-md-offset-0 col-sm-offset-0 col-xs-offset-1 footer-contents"
  }, [_c('ol', {
    staticClass: "address-infos"
  }, [_c('li', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-md-4 col-sm-5 col-xs-4"
  }, [_vm._v(_vm._s(_vm.$t("footer.tel_label")))]), _vm._v(" "), _c('p', {
    staticClass: "col-md-8 col-sm-7 col-xs-8"
  }, [_vm._v(_vm._s(_vm.$t("footer.tel_val")))])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-md-4 col-sm-5 col-xs-4"
  }, [_vm._v(_vm._s(_vm.$t("footer.email_label")))]), _vm._v(" "), _c('p', {
    staticClass: "col-md-8 col-sm-7 col-xs-8"
  }, [_vm._v("devops@tintinhealth.com")])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-md-4 col-sm-5 col-xs-4"
  }, [_vm._v(_vm._s(_vm.$t("footer.company_address_label")))]), _vm._v(" "), _c('p', {
    staticClass: "col-md-8 col-sm-7 col-xs-8"
  }, [_vm._v(_vm._s(_vm.$t("footer.company_address")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-6 col-xs-12 col-md-offset-1 col-sm-offset-0"
  }, [_c('ol', {
    staticClass: "row qr-code-wrap"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("footer.copyright")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("footer.case_number")))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-sm-3 col-xs-4 footer-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../src/assets/images/footer-left.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "codeImg col-md-3 col-sm-3 col-xs-3"
  }, [_c('img', {
    attrs: {
      "src": require("../../../src/assets/images/web_andriod.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6369f3f3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Footer.vue
// module id = 270
// module chunks = 1